import { render, staticRenderFns } from "./TabelaDeItensDeItem.vue?vue&type=template&id=01fc25a1&scoped=true"
import script from "./TabelaDeItensDeItem.vue?vue&type=script&setup=true&lang=js"
export * from "./TabelaDeItensDeItem.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TabelaDeItensDeItem.vue?vue&type=style&index=0&id=01fc25a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fc25a1",
  null
  
)

export default component.exports